<template>
  <div class="space-y-4 rounded-md bg-white p-6 shadow-md">
    <div>
      <div class="text-xl font-semibold text-gray-700">
        {{ formulario.nombre }}
      </div>
      <div class="text-base text-gray-500" v-if="formulario.descripcion">
        {{ formulario.descripcion }}
      </div>
      <div v-if="formulario.otroDato">
        <strong>{{ formulario.otroDato }}</strong>
      </div>
    </div>
    <HorizontalStepper
      class="bg-white"
      :steps="steps"
      :initial-step="1"
      v-model="currentStep"
      @change="({ from, to }) => onStepChange(from, to)"
    />
    <div>
      <transition
        enter-active-class="transition-opacity duration-200 ease-in"
        leave-active-class="transition-opacity duration-200 ease-out"
        enter-class="opacity-0"
        leave-to-class="opacity-0"
        mode="out-in"
      >
        <keep-alive>
          <Component
            class="bg-white p-6 shadow ring-1 ring-black ring-opacity-5 md:rounded-md md:p-8"
            ref="currentStep"
            v-if="currentStep"
            :is="currentStep.component(formulario)"
          />
        </keep-alive>
      </transition>
    </div>
    <div class="flex justify-center">
      <button
        class="mx-2 rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm transition duration-150 ease-in-out hover:bg-cool-gray-200 focus:outline-none focus:ring focus:ring-blue-200 focus:ring-opacity-50 active:bg-cool-gray-200"
        @click="navigateBack"
      >
        Volver
      </button>
    </div>
  </div>
</template>

<script>
import { REFERENCIA_COMPROBANTES } from '@/util/comprobantes';
import { useAcreditacionServicio, useSession } from '@colescba/ui';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'FormularioComprobante',

  mixins: [useSession(), useAcreditacionServicio()],

  props: {
    idFormulario: { type: String, required: true },
    comprobante: { type: Object, required: false },
  },

  created() {
    this.setFormulario(this.formularios.find(f => f.idFormulario === this.idFormulario))
    if (this.formulario.private && !this.userHasAnyRole(this.formulario.roles)) {
      this.$toast.open({
        message: 'No posee permisos para acceder a este formulario.',
        type: 'warning',
        duration: 2500,
        dismissible: true,
      })
      this.$router.replace({ name: 'Home' })
    }

    if (this.comprobante) {
      const referencia = this.obtenerReferenciaComprobante()
      let data = {
        comprobante: this.comprobante,
        tipoDeuda: referencia.deuda_tipo_id || null,
        categoriaId: referencia.deuda_categoria_id || null,
      }
      this.$store.dispatch('stepper/actualizarCajaForm', data)
    }
  },
  computed: {
    ...mapState({
      formularios: state => state.app.formularios,
      steps: state => state.stepper.steps,
      formulario: state => state.stepper.formulario,
    }),
    currentStep: {
      get() {
        return this.$store.state.stepper.currentStep
      },
      set(value) {
        this.$store.commit('stepper/setCurrentStep', value)
      },
    },
  },

  methods: {
    navigateBack() {
      if (this.comprobante) {
        this.$router.replace({ name: 'generar-comprobante' })
      } else {
        this.$router.go(-1)
      }
    },
    obtenerReferenciaComprobante() {
      const primerosTresDigitos = this.comprobante.numero_comprobante.substring(0, 3)
      return (
        REFERENCIA_COMPROBANTES.find(item => {
          return item.referencia.toString() === primerosTresDigitos
        }) || {}
      )
    },
    ...mapMutations({
      setFormulario: 'stepper/setFormulario',
    }),
    onStepChange(from, to) {
      // Voy para adelante pero el formulario no es valido
      if (from && to.index > from.index && !from.valid) return

      // Voy para adelante, asumo que form es valido, parche para que setee la data del form en vuex
      if (from && to.index > from.index) this.$refs.currentStep.onNextStep()

      this.currentStep = to
    },
  },

  beforeDestroy() {
    this.$store.dispatch('stepper/resetState')
  },
}
</script>
